import { Box } from '@mui/material';
import React from 'react';
import HeroHeaderSection from './components/HeroHeaderSection';
import HeroSectionVideos from './components/HeroSectionVideos';
import { heroSectionStyles } from './heroSectionStyles';

export default function HeroSection() {
	return (
		<Box id="hero-section-container" sx={[heroSectionStyles.heroSectionContainer]}>
			<HeroSectionVideos />
			<HeroHeaderSection />
		</Box>
	);
}
